<div #sidebar__header class="sidebar__header">
	<div class="sidebar__header-title-box">
		<button *ngIf="!show_custom_button" class="close" aria-role="button" aria-label="Close dialog" (click)="INDRA_handleClose()">
			<div class="close__icon-wrapper">
					<app-svg
					class="header-breadcrumb__icon"
					svg="icons.svg#general--arrow--left-no_margin"
					aria-hidden="true" [alt]="'Arrow left icon'"
				></app-svg>
			</div>
		</button>
		<ng-content *ngIf="show_custom_button"  select="[custom-button]"></ng-content>
	
		<div class="sidebar__heading">
			
			<!-- <h1 class="title-h1" id="sidebar__title">
					{{ INDRA_printSidebarTitle() }}
				</h1>
				<label *ngIf="INDRA_hasSidebarLabel()" class="sidebar__label">
					{{ INDRA_printSidebarLabel() }}
				</label> -->
			
			<!-- with flight details -->
			<h1 class="title-h1" id="sidebar__title" *ngIf="INDRA_printSidebarTitleDeparture()">
				{{'bookingDetails.sidebars.details.texts.from' | ibeadmin:'sync'}}
				{{ INDRA_printSidebarTitleDeparture() }}
				{{'bookingDetails.sidebars.details.texts.to' | ibeadmin:'sync'}}
				{{INDRA_printSidebarTitleArrival()}}
			</h1>
			<label *ngIf="!INDRA_printTitle()" class="sidebar__label">
				{{'bookingDetails.sidebars.details.texts.totalDuration' | ibeadmin:'sync'}} :
				<!-- {{INDRA_printSidebarLabel()}} -->
			</label>
			
			<!-- ancillaries and other sidebars -->
			<h1 class="title-h1" id="sidebar__title" *ngIf="INDRA_printTitle()">
				{{INDRA_printTitle()}}
			</h1>
			<label *ngIf="INDRA_hasSidebarLabel()" class="sidebar__label">
				{{ INDRA_printSidebarLabel() }}
			</label>
	
			<!-- without flight details -->
			<h1 class="title-h1" id="sidebar__title" *ngIf="!INDRA_printTitle() && !INDRA_printSidebarTitleDeparture()">
				{{'bookingDetails.sidebars.details.texts.flightDetails' | ibeadmin:'sync'}}
			</h1>
			
			<ng-content select="[custom-label]" class="sidebar__actions"></ng-content>
			<app-svg
				*ngIf="INDRA_hasSidebarLabelImage()"
				class="sidebar__label--image"
				svg="INDRA_printSidebarLabelImage()"
				aria-hidden="true" [alt]="INDRA_printSidebarLabel()"
			></app-svg>
		</div>
	</div>	
	<ng-content select="[actions]" class="sidebar__actions"></ng-content>
</div>
